import React from 'react'

export interface AgentChatLaunchContext {
  initialInput?: string
  tableViewContextId?: string
  documentContextId?: string
  hubContextId?: string
  reset?: boolean
  autoSubmit?: boolean
}

/** Stable interface — do NOT use ReturnType<typeof _useApplicationProvider> */
export interface ApplicationStore {
  snackbarMessage: any // ISnackbarObject
  setSnackbarMessage: (next: any) => void
  sidebarWidth: number
  setSidebarWidth: (n: number) => void
  minSidebarWidth: number
  maxSidebarWidth: number
  templatesModal: boolean
  setTemplatesModal: (v: boolean) => void
  displayErrorMessage: (e: unknown) => void
  clearSnackbar: () => void
  supportChatContext: { errorMessage: string; diagnostics: string; path?: string; method?: string } | null
  openSupportChat: (
    context: { errorMessage: string; diagnostics: string; path?: string; method?: string } | null
  ) => void
  agentChatLaunchContext: AgentChatLaunchContext | null
  launchAgentChat: (context: AgentChatLaunchContext | null) => void
  clearAgentChatLaunchContext: () => void
}

/** Context generic stays EXACTLY the same everywhere */
type Ctx = ApplicationStore | undefined

/** Cache context on globalThis so HMR reuses the same object */
const KEY = '__APP__ApplicationContext'
const existing = (globalThis as any)[KEY] as React.Context<Ctx> | undefined

export const ApplicationContext: React.Context<Ctx> = existing ?? React.createContext<Ctx>(undefined)

if (!(globalThis as any)[KEY]) {
  ;(globalThis as any)[KEY] = ApplicationContext
}

/** Hook */
export const useApplicationStore = (): ApplicationStore => {
  const ctx = React.useContext(ApplicationContext)
  if (!ctx) throw new Error('useApplication can only be used within an Application context')
  return ctx
}

/** If this file changes, skip Fast Refresh and hard-reload to avoid stale consumers */
if (import.meta.hot) {
  import.meta.hot.accept(() => import.meta.hot.invalidate())
}
